import { useQuery } from "@tanstack/react-query";

import { useAuthContext } from "~/contexts/auth";
import { useCart } from "~/hooks/use-cart";
import useSubscriptions from "~/hooks/use-subscriptions";

export const LOYALTY_REWARDS_QUERY_KEY = "loyaltyRewards";

function getCartSignature(cart: ReturnType<typeof useCart>): string {
  return (cart?.ShoppingCart?.Lines ?? [])
    .map((line) => `${line.ID}:${line.QuantityOpen ?? ""}:${line.DiscountCouponCode ?? ""}`)
    .join("|");
}

export default function useLoyaltyRewards({ onlyAvailable = false }: { onlyAvailable?: boolean } = {}) {
  const { isAuthenticated, user, getUserLoyaltyRewards } = useAuthContext();
  const { isUserSubscribedToLoyalty } = useSubscriptions();
  const cart = useCart();
  const orderId = cart?.ShoppingCart?.ID ? String(cart.ShoppingCart.ID) : undefined;

  return useQuery({
    queryKey: [LOYALTY_REWARDS_QUERY_KEY, user?.ID, orderId, getCartSignature(cart), onlyAvailable],
    enabled: isAuthenticated && !!user?.ID && !!isUserSubscribedToLoyalty,
    queryFn: () => {
      return getUserLoyaltyRewards(orderId, onlyAvailable);
    },
    keepPreviousData: true,
  });
}
